import { apiProvider } from '../utilities/provider';
import { ApiUrlConstants } from './apiUrl.constants';

export const smsService = {
    mobileNoAndDeviceID,
    verifyOTP
};

function mobileNoAndDeviceID(mobileNo, deviceId) {
    var model = {
        deviceUuid: deviceId,
        mobileNumber: mobileNo
    }
    return apiProvider.fetch.post(ApiUrlConstants.AccessControl.SmsEndPoint, model);
}

function verifyOTP(otp, mobileNo, deviceId) {
    var model = {
        OtpNumber: otp,
        MobileNumber: mobileNo,
        DeviceUuid: deviceId,
    }
    return apiProvider.fetch.post(ApiUrlConstants.AccessControl.SmsVerifyOTPEndPoint, model);
}